
import {zip as observableZip,  Observable } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CategoryService } from '../../services/category.service';
import { LocationService } from '../../services/location.service';
import { SelectableCategory } from '../../models/categories/category.models';
import { LocationsByRegionDto, SelectableRegion, SelectableLocation } from '../../models/locations/location.models';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AccountService } from '../../services/account.service';
import { GetExtraAlertsDto, MatchPreferencesDto, UpdateMatchPreferencesDto } from '../../models/account/account.models';
import { CategoryAndLocationHelpers } from '../../helpers';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { PaidFeatureUpsellService } from '../../services/paid.feature.upsell.service';

@Component({
    selector: 'extra-alerts-list',
    template: require('./extra.alerts.list.component.html'),
    styles: [require('./personal.account.shared.css')]
})
export class ExtraAlertsListComponent implements OnInit, OnDestroy {

    subscribed: boolean;
    extraAlerts: GetExtraAlertsDto[];

    constructor(private readonly categoryService: CategoryService,
        private readonly locationService: LocationService,
        private readonly accountService: AccountService,
        private readonly helpers: CategoryAndLocationHelpers,
        loggedInUserService: LoggedInUserService,
        private readonly paidFeatureUpsellService: PaidFeatureUpsellService) {

        var user = loggedInUserService.getCurrentUser();
        this.subscribed = !user.canAdHoc('notSubscribed');
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');

        var eventObservable = this.accountService.getExtraAlerts();

        observableZip(
            eventObservable,
            (extraAlerts: GetExtraAlertsDto[]) => ({ extraAlerts }))
            .subscribe(results => {
                this.extraAlerts = results.extraAlerts;
            });
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }

    showAlertInfoDialog() {
        this.paidFeatureUpsellService.openDefault();
    }

    removeAlert(id: number) {
        this.accountService.deleteAlert(id)
            .subscribe(() => {
                this.ngOnInit();
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/extra.alerts.list.component.ts